require('./ruleBuilderLeftNav.i18n.json');
require('./ruleBuilderLeftNav.tpl.html');
require('./ruleBuilderLeftNavController.js');

const RuleBuilderLeftNavComponent = {
    templateUrl: '/configuration/formEditor/content/rule/leftNav/ruleBuilderLeftNav.tpl.html',
    controller: 'ruleBuilderLeftNavController',
    bindings: {
        uiFormTemplate: '<',
        showNewRuleButton: '<',
        onSelectedItemChange: '&',
        canUserManageFormRules: '<'
    }
};

angular.module('ums.configuration')
    .component('uiRuleBuilderLeftNav', RuleBuilderLeftNavComponent);
